import { LabelMetaData } from '@feature/smart-reports-core/models/label-meta-data';

export function createFormatObject(labelMetadata): object {
	const formatObject: any = {};
	const keys = Object.keys(labelMetadata);

	keys.forEach((elem) => {
		formatObject[elem] = prepareFormatByLabelMetaData(labelMetadata, elem);
	});
	return formatObject;
}

export function prepareFormatByLabelMetaData(
	labelMetadata: LabelMetaData,
	field: string,
	isCompactView: boolean = false
): Intl.NumberFormat | null {
	if (labelMetadata[field]) {
		const { numberOfDecimal, format, type, currency, isPercentage } = labelMetadata[field];
		if (type === 'float' || type === 'long' || type === 'double') {
			const numberFormatStyle = prepareNumberFormatStyle(currency, isPercentage);
			return new Intl.NumberFormat(format, {
				style: numberFormatStyle,
				minimumFractionDigits: numberOfDecimal,
				maximumFractionDigits: numberOfDecimal,
				currency: numberFormatStyle === 'currency' ? currency : undefined,
				notation: isCompactView ? 'compact' : 'standard',
				compactDisplay: 'long',
			});
		}
	}
	return null;
}

export function prepareNumberFormatStyle(
	currency?: string,
	isPercentage?: boolean
): 'currency' | 'percent' | 'decimal' {
	if (currency && currency !== 'none' && currency !== 'null') {
		return 'currency';
	} else if (isPercentage) {
		return 'percent';
	} else {
		return 'decimal';
	}
}

export function createBasicFormatObject(labelMetadata: LabelMetaData, field: string): Intl.NumberFormat {
	const { format } = labelMetadata[field];
	return prepareBaseFormat(format);
}

export function prepareBaseFormat(format: string = 'tr-TR'): Intl.NumberFormat {
	return new Intl.NumberFormat(format, {
		style: 'decimal',
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	});
}
